import React from 'react';
import AnimatedSection from './AnimatedSection';
import SectionIntro from './SectionIntro';

const technologies = [
  'Artificial Intelligence',
  'Cloud Computing',
  'Real-Time Systems',
  'Modern Web Applications',
  'Mobile Platforms',
  'Secure APIs',
  'Data Analytics',
  'Machine Learning',
];

const Technology: React.FC = () => {
  return (
    <section className="section-pad relative">
      <div className="max-w-7xl mx-auto">
        <SectionIntro
          align="center"
          label="Technology"
          title="Enterprise-grade foundations."
          body="Modern infrastructure designed for reliability, security, and scale across hospitality networks."
          className="mb-14"
        />

        <AnimatedSection animation="fade-in">
          <div className="flex flex-wrap justify-center gap-3 md:gap-4">
            {technologies.map((tech) => (
              <div
                key={tech}
                className="px-5 py-3 md:px-6 md:py-3.5 rounded-full border border-surface-border bg-surface-card/60 text-sm md:text-base text-muted hover:text-white hover:border-primary-500/40 hover:bg-primary-500/5 transition-all duration-300"
              >
                {tech}
              </div>
            ))}
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default Technology;
